import { SETTLEMENT_STYLES } from "../../../style/styles";

export default function AddCustomMedicalItemField({ label, children }) {
  return (
    <div className="flex w-full flex-col gap-1">
      <span className="text-sm font-medium" style={SETTLEMENT_STYLES.infoFieldLabel}>
        {label}
      </span>
      {children}
    </div>
  );
}
